module.exports = __webpack_public_path__ + "img/004-bald.6cdee51a.svg";